import CustomTable from "@/components/customTable/CustomTable";
import { Button, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

function TripsTable({ trips }) {
  const [pageable, setPageable] = useState({
    pageIndex: 0,
    pageSize: 5,
  });

  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    setTableData(
      trips.slice(
        pageable.pageIndex * pageable.pageSize,
        (pageable.pageIndex + 1) * pageable.pageSize,
      ),
    );
  }, [trips, pageable.pageIndex]);

  const cols = useMemo(() => [
    {
      cellRenderer: (x) => {
        return (
          <Typography
            sx={{ fontFamily: "Vazirmatn", fontSize: "0.8em" }}
            key={`name_${x.data.id}`}
          >
            {`${x.data.name ?? ""}`}
          </Typography>
        );
      },
      headerName: "نام",
      width: 180,
    },
    {
      cellRenderer: (x) => {
        return (
          <Typography
            sx={{ fontFamily: "Vazirmatn", fontSize: "0.8em" }}
            key={`city_${x.data.id}`}
          >
            {`${x.data.city ?? ""}`}
          </Typography>
        );
      },
      headerName: "منطقه",
      width: 90,
    },
    {
      cellRenderer: (x) => {
        return (
          <Typography
            sx={{ fontFamily: "Vazirmatn", fontSize: "0.6em" }}
            key={`role_${x.data.id}`}
          >
            {`${x.data.role}`}
          </Typography>
        );
      },
      headerName: "سمت",
      width: 180,
    },
    {
      cellRenderer: (x) => {
        return (
          <Typography
            variant="caption"
            key={`date_${x.data.id}`}
            sx={{ fontFamily: "Vazirmatn", fontSize: "0.8em" }}
          >
            {`${x.data?.start ?? ""}  -  ${x.data?.end ?? ""}`}
          </Typography>
        );
      },
      headerName: "تاریخ",
      width: 150,
    },
    {
      cellRenderer: (x) => {
        return (
          <Button
            variant="contained"
            color={x.data.status === "در حال برگزاری" ? "secondary" : "error"}
            key={`status_${x.data.id}`}
            sx={{ fontFamily: "Vazirmatn", fontSize: "0.8em" }}
          >
            {x.data.status}
          </Button>
        );
      },
      headerName: "وضعیت",
      width: 100,
    },
  ]);

  return (
    <>
      <CustomTable
        customHeight={"260px"}
        totalElements={trips.length}
        completePagination={false}
        allowChangePageSize={false}
        onPageChange={(pageIndex, _) => {
          setPageable({
            pageIndex: pageIndex,
            pageSize: 5,
          });
        }}
        pageSize={pageable.pageSize}
        currentPage={pageable.pageIndex}
        rowData={tableData}
        columns={cols}
      />
    </>
  );
}

export default TripsTable;
